import React from 'react';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import i18n from '../../../../../translations/i18n';
import { ClientRetentionEntry } from '../../../../../api/clientsApi/interfaces';
import {
  AgentsAvatarCell,
  DateCell,
  ValueCell,
  ValueListCell,
} from '../../../../../components/data-table';

export const columns: GridColDef[] = [
  {
    field: 'daysLeft',
    headerName: i18n.t('clients:relationshipManagement.columns.daysLeft'),
    width: 110,
    hideable: false,
    renderCell: (params) => {
      const row = params.row;

      return (
        <ValueCell>
          {row.daysLeft !== null
            ? i18n.t('words.day', { count: row.daysLeft })
            : undefined}
        </ValueCell>
      );
    },
  },
  {
    field: 'lastContactDate',
    headerName: i18n.t(
      'clients:relationshipManagement.columns.lastContactDate'
    ),
    width: 200,
    hideable: false,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.lastContactDate} withTime={false} />;
    },
  },
  {
    field: 'dueDate',
    headerName: i18n.t('clients:relationshipManagement.columns.dueDate'),
    width: 160,
    hideable: false,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.dueDate} withTime={false} />;
    },
  },
  {
    field: 'name',
    headerName: i18n.t('entities:client.name'),
    width: 200,
    hideable: false,
  },
  {
    field: 'responsibleAgents',
    headerName: i18n.t('entities:client.responsibleAgents'),
    filterable: false,
    minWidth: 220,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <AgentsAvatarCell agents={row.responsibleAgents} />;
    },
  },
  {
    field: 'contractedProducts',
    headerName: i18n.t('entities:client.contractedProducts'),
    width: 300,
    renderCell: (params: GridRenderCellParams<ClientRetentionEntry>) => {
      const products = params.row.contractedProducts;

      return (
        <ValueListCell values={products?.map((product) => product.name)} />
      );
    },
  },
  {
    field: 'potentialProducts',
    headerName: i18n.t('entities:client.potentialProducts'),
    width: 300,
    renderCell: (params: GridRenderCellParams<ClientRetentionEntry>) => {
      const products = params.row.potentialProducts;

      return (
        <ValueListCell values={products?.map((product) => product.name)} />
      );
    },
  },
];
